import Logo from './logo'

// eslint-disable-next-line max-lines-per-function
export function HeaderShort({
  disableLogoClick = true,
  host,
}: {
  disableLogoClick?: boolean
  host?: string
}) {
  return (
    <header className="bg-brand-white shadow-two sticky left-0 top-0 z-50 w-full">
      <div className="md:w-9/10 mx-auto flex items-center px-16 py-3 md:px-0 lg:max-w-[1080px]">
        <section className="flex flex-1 items-center">
          <aside className="flex items-center">
            <div className="mr-12">
              <Logo disablePointer={disableLogoClick} host={host} />
            </div>
          </aside>
        </section>
      </div>
    </header>
  )
}
